import { motion } from 'motion/react'
import { useTranslation } from 'react-i18next'
import { normalizeToolName, humanizeToolName } from '../../../shared/utils/tools'

interface Props {
  toolName: string
}

/**
 * Pulsing gold dot + localized tool label.
 * Shows during tool execution when no text has arrived yet.
 */
export function ToolActivityIndicator({ toolName }: Props) {
  const { t } = useTranslation('chat')
  const normalized = normalizeToolName(toolName)
  const label = t(`tools.activity.${normalized}`, humanizeToolName(normalized))

  return (
    <div className="flex items-center gap-2 p-3">
      <motion.div
        className="w-2 h-2 rounded-full bg-gold/70"
        animate={{ opacity: [0.4, 1, 0.4] }}
        transition={{ duration: 1.2, repeat: Infinity, ease: 'easeInOut' }}
      />
      <span className="text-pearl/50 text-xs">{label}</span>
    </div>
  )
}
